import { useState } from "react";
import SequenceService from "../Services/SequenceService";
import ModalService from "../Services/ModalService";
import { MODAL_SIMULATE_DATES } from "../constants";
import moment from "moment";

function SimulateDatesModal({ sequence_id }) {
    const [count, setCount] = useState('');
    const [dates, setDates] = useState([]);
    const [loading, setLoading] = useState(false);

    async function onSimulate() {
        setLoading(true);
        let response = await SequenceService.generateDatesUsingSequenceSettings(sequence_id, count);
        setDates(response.dates || []);
        setLoading(false);
    }

    function hideModal() {
        ModalService.closeSimulateDatesModal();
        setDates([]);
        setCount('');
    }

    return (
        <div>
            <div className="modal fade" id={MODAL_SIMULATE_DATES} tabIndex="-1" aria-labelledby={MODAL_SIMULATE_DATES} aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title bold">Simulate dates for leads</h6>
                            <button type="button" className="btn-close fs-12" onClick={hideModal}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="bold fs-12">Leads count</label>
                                <input type="number" className="form-control" value={count} onChange={(e) => setCount(e.target.value)} />
                            </div>
                            <button disabled={!count || loading} onClick={onSimulate} className="btn btn-primary btn-sm mb-3">
                                {loading && <i className="fas fa-spinner fa-spin me-2"></i>}
                                Simulate
                            </button>
                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                {dates.length > 0 && dates.map((date, i) => (
                                    <div key={i} style={{ fontSize: '13px' }}>
                                        {i + 1}.{' '}
                                        {moment(date).format('llll')}
                                    </div>
                                ))}
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button onClick={hideModal} className="btn btn-secondary btn-sm fs-13">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SimulateDatesModal;
